import React, {useEffect} from 'react';
import {listaOrlando} from "../../../../../data/sinks/granit-sinks";
import ProductGrid from "../../../../../components/prodotti/ProductGrid";

const GranitOrlandoPage = () => {

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <>
            <ProductGrid prodotti={listaOrlando} name={"Our Granit Orlando"}/>
        </>
    );
};

export default GranitOrlandoPage;
